// Barber Discount Theme JS

document.addEventListener('DOMContentLoaded', function() {

  // Transparent header scroll detection (homepage)
  var header = document.querySelector('.header');
  if (document.body.classList.contains('template-index') && header) {
    var onScroll = function() {
      if (window.scrollY > 60) {
        header.classList.add('scrolled');
      } else {
        header.classList.remove('scrolled');
      }
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  // Mobile menu toggle
  var toggle = document.querySelector('.mobile-toggle');
  var mobileMenu = document.querySelector('.mobile-menu');

  if (toggle && mobileMenu) {
    toggle.addEventListener('click', function() {
      var isOpen = mobileMenu.classList.toggle('active');
      toggle.setAttribute('aria-expanded', isOpen);
      document.body.style.overflow = isOpen ? 'hidden' : '';
    });
  }

  // Product gallery thumbnails
  var thumbs = document.querySelectorAll('.product-thumb');
  var slides = document.querySelectorAll('.product-gallery-slide');

  if (thumbs.length > 0) {
    thumbs.forEach(function(thumb) {
      thumb.addEventListener('click', function() {
        var index = this.getAttribute('data-index');

        slides.forEach(function(s) { s.classList.remove('active'); });
        thumbs.forEach(function(t) { t.classList.remove('active'); });

        var target = document.querySelector('.product-gallery-slide[data-index="' + index + '"]');
        if (target) target.classList.add('active');
        this.classList.add('active');
      });
    });
  }

  // Product accordions (smooth)
  var accordionHeaders = document.querySelectorAll('.product-accordion-header');
  accordionHeaders.forEach(function(header) {
    header.addEventListener('click', function() {
      var accordion = this.parentElement;
      var body = accordion.querySelector('.product-accordion-body');
      if (!body) return;

      if (accordion.classList.contains('active')) {
        accordion.classList.remove('active');
      } else {
        accordion.classList.add('active');
      }
    });
  });

  // Smooth scroll for anchor links
  document.querySelectorAll('a[href^="#"]').forEach(function(link) {
    link.addEventListener('click', function(e) {
      var target = document.querySelector(this.getAttribute('href'));
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

  // Scroll reveal animations
  var reveals = document.querySelectorAll('.benefit-editorial-item, .trust-card, .product-card, .testimonial-card, .story-text');
  if (reveals.length > 0 && 'IntersectionObserver' in window) {
    var revealObserver = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('revealed');
          revealObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });

    reveals.forEach(function(el) {
      el.classList.add('reveal');
      revealObserver.observe(el);
    });
  }

  // Trust number count-up animation
  var trustNumbers = document.querySelectorAll('.trust-number');
  if (trustNumbers.length > 0 && 'IntersectionObserver' in window) {
    var countObserver = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          animateCount(entry.target);
          countObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.5 });

    trustNumbers.forEach(function(el) { countObserver.observe(el); });
  }

  function animateCount(el) {
    var text = el.textContent.trim();
    var match = text.match(/^(\d+)/);
    if (!match) return;

    var target = parseInt(match[1], 10);
    var suffix = text.replace(match[1], '');
    var duration = 1500;
    var start = 0;
    var startTime = null;

    function step(timestamp) {
      if (!startTime) startTime = timestamp;
      var progress = Math.min((timestamp - startTime) / duration, 1);
      var eased = 1 - Math.pow(1 - progress, 3);
      var current = Math.floor(eased * target);
      el.textContent = current + suffix;
      if (progress < 1) requestAnimationFrame(step);
    }

    requestAnimationFrame(step);
  }
});
